import React, { Component } from "react";
import { connect } from 'react-redux';
import OrgChart from '../../../components/OrganizationSetup/OrgChart/OrgChart';
import EnterpriseBreadcrumb from '../../../components/EnterpriseBreadcrumb/EnterpriseBreadcrumb';

class OrgChartManagement extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return <div className="mb20 mt70">
      <EnterpriseBreadcrumb linkText="Enterprise Management" link="" activeText="Import Org Chart" {...this.props}/>
      <OrgChart {...this.props}/>
    </div>;
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.profile,
  }
}

export default connect(mapStateToProps)(OrgChartManagement);